define((require) => {
    "use strict";

    const ImprovedModel             = require("shared/zbone/ImprovedModel");
    const NotificationBar           = require("editor/ui/notificationbar/NotificationBar");
    const CONSTANTS                 = require("ui/editor/email/Constants");

    /**
     * The view model for removing incompatible widgets.
     *
     * @class IncompatibleWidgetsPopupModel
     * @constructor
     */
    return ImprovedModel.extend({
        defaults: {
            state: CONSTANTS.CLOSE
        },
        experienceModel: null,
        allIncompatibleWidgets: [],
        notificationId: null,
        systemMessage: null,

        initialize: function() {
            this.allIncompatibleWidgets = this.get("allIncompatibleWidgets");
            this.viewModel = this.get("viewModel");
            this.systemMessage = this.get("systemMessage");
            this.listenTo(this, "change:state", this._stateChangeHandler);
        },

        _stateChangeHandler: function() {
            if (this.get("state") === CONSTANTS.OPEN_NOTIFICATION) {
                this.systemMessage = this.systemMessage.replace(": ", `: ${this.get("widgetsName")}`);
                this.notificationId = NotificationBar.open({message: this.systemMessage, action: "removeIncompatibleWidgets"}, {
                    closeable: false,
                    popupModel: this
                });
            }
            if (this.get("state") === CONSTANTS.REMOVE_WIDGETS) {
                // close the popup and then delete the invalid widgets
                this.set("state", CONSTANTS.CLOSE);
                const scene = this.viewModel.get("activeLayerSceneModel");
                scene.deleteWidgets(this.allIncompatibleWidgets, {cause: "GROUP"});
                this.allIncompatibleWidgets = [];
                NotificationBar.close({id: this.notificationId});
            }
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/email/IncompatibleWidgetsPopupModel.js